<template>
  <main class="main" role="main">
    <div class="page">
      <div class="inner">
        <div class="lnb">
          <ul>
            <li><p class="home"></p></li>
            <li><p>회원 공간</p></li>
            <li><p>배너 안내</p></li>
          </ul>
        </div>
        <div class="page_ttl">
          <h1 class="h1">
            <span>배너 안내</span>
          </h1>
        </div>
        <div class="page_con">
          <div class="inform_box center mb60">
            <div>
                        <span class="color">
                            (사)한국외식산업협회에서는 아래와 같이 홈페이지 배너 광고를 진행하고 있습니다.<br>
                            외식산업발전을 위해 노력해 주시는 기관 및 업체에 늘 감사드립니다.
                        </span>
            </div>
          </div>
          <div class="rule_list">
            <ul class="rule_list_ul">
              <li class="rule_list_li">
                <div class="rule_list_ttl">
                  <h3 class="h3">신청 절차</h3>
                </div>
                <div class="rule_list_con">
                  <p>신청서 접수 → 담당자 승인 → 광고비 입금 → 광고 게재</p>
                </div>
              </li>
              <li class="rule_list_li">
                <div class="rule_list_ttl">
                  <h3 class="h3">신청 방법</h3>
                </div>
                <div class="rule_list_con">
                  <ol class="nb_dot" style="padding: 0;">
                    <li><span class="ol_li_txt">광고 신청서 작성 후 이메일로 송부해 주시기 바랍니다.</span></li>
                    <li><span class="ol_li_txt">신청서 승인은 접수 후 7일 이내에 이루어집니다.</span></li>
                  </ol>
                  <p>
                    <br>
                    <!-- 한국외식산업협회 홈페이지 배너 안내 내 퇴사자명 성명 삭제요청 (서남아이에스 임현아, 2024-08-30) -->
                    <!-- <b>※ 문의 : (사)한국외식산업협회 김민아 Tel) 02-449-5009</b> -->
                    <b>※ 문의 : (사)한국외식산업협회 Tel) 02-449-5009</b>
                  </p>
                </div>
              </li>
              <li class="rule_list_li">
                <div class="rule_list_ttl">
                  <h3 class="h3">광고 내용</h3>
                </div>
                <div class="rule_list_con">
                  <ol class="dot_big" style="padding: 0;">
                    <li>
                                        <span class="ol_li_txt">
                                            기업 소개, 제품 소개, 행사 안내 등
                                            <span class="small_color">※ 배너는 신청업체가 직접 제작하여야 합니다.</span>
                                        </span>
                    </li>
                    <li><span class="ol_li_txt">광고 신청사가 사회적으로 물의를 일으킨 경우</span></li>
                    <li><span class="ol_li_txt">허위사실을 포함하여 부당한 홍보를 진행한 경우</span></li>
                    <li><span class="ol_li_txt">기타 협회의 목적에 위배되는 경우</span></li>
                  </ol>
                </div>
              </li>
              <li class="rule_list_li">
                <div class="rule_list_ttl">
                  <h3 class="h3">광고 위치 및 단가</h3>
                </div>
                <div class="rule_list_con">
                  <div class="table">
                    <div class="row head">
                      <div class="cell"><p>위치</p></div>
                      <div class="cell"><p>배너크기</p></div>
                      <div class="cell"><p>파일형식</p></div>
                      <div class="cell"><p>단가</p></div>
                    </div>
                    <div class="row">
                      <div class="col" style="flex: 2;">
                        <div class="row">
                          <div class="cell"><p>메인</p></div>
                          <div class="cell">
                            <p class="left">
                              PC: 1200x480 px<br>
                              모바일: 1080x630 px
                            </p>
                          </div>
                        </div>
                        <div class="row">
                          <div class="cell"><p>하단</p></div>
                          <div class="cell">
                            <p class="left">
                              PC: 240x120 px
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="col">
                        <div class="cell"><p>jpg,png,gif</p></div>
                      </div>
                      <div class="col">
                        <div class="cell"><p>협의 후 진행</p></div>
                      </div>
                    </div>
                  </div>
                  <p class="small_color">
                    <br>
                    ※ 메인 및 하단배너는 5개 이하의 이미지 롤링배너입니다.<br>
                    ※ 계약기간은 월 단위입니다.
                  </p>
                  <div class="banner_explain">
                    <img src="@/assets/static/images/img_banner_explain.png" alt="">
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: 'space-banner-index',
  description: '배너 안내'
}
</script>

<style scoped>

</style>
